import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Trash2 } from "lucide-react";
import { api, errMsg, fmtDate, SITE } from "@/lib/api";
import { Input } from "@/components/ui/input";

const link = (slug) => `${SITE}/join/${slug}`;
const MSG = {
  it: (i) => `Ciao ${i.artist_name}, ho ascoltato ${i.track ? `"${i.track}"` : "la tua musica"} e mi è piaciuto molto. Ti ho selezionato come Founding Artist per Fuorionda, una radio 24/7 per artisti indipendenti: iscrizione gratuita, 3 mesi Pro in regalo. Il tuo invito: ${link(i.slug)}`,
  en: (i) => `Hey ${i.artist_name}, I listened to ${i.track ? `"${i.track}"` : "your music"} and loved it. I've selected you as a Founding Artist for Fuorionda, a 24/7 radio for independent artists: free to join, 3 months of Pro as a gift. Your invite: ${link(i.slug)}`,
};
const STATUS = { created: "text-slate-400", opened: "text-[#FFB800]", signed_up: "text-[#00F5D4]" };

const copy = (t) => { navigator.clipboard.writeText(t); toast.success("Copied"); };

export const Invites = () => {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ artist_name: "", instagram: "", track: "" });
  const load = () => api.get("/admin/invites").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const create = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/admin/invites", f); copy(MSG.it(data)); setF({ artist_name: "", instagram: "", track: "" }); load(); } catch (er) { toast.error(errMsg(er)); }
  };
  const del = async (id) => { await api.delete(`/admin/invites/${id}`); load(); };
  return (
    <div className="space-y-6" data-testid="admin-invites">
      <form onSubmit={create} className="panel grid gap-3 p-6 md:grid-cols-4" data-testid="invite-form">
        <Input required placeholder="Artist name" value={f.artist_name} onChange={(e) => setF({ ...f, artist_name: e.target.value })} className="border-white/10 bg-[#07090E]" data-testid="invite-artist-name" />
        <Input placeholder="@instagram" value={f.instagram} onChange={(e) => setF({ ...f, instagram: e.target.value })} className="border-white/10 bg-[#07090E]" data-testid="invite-instagram" />
        <Input placeholder="Track you liked (optional)" value={f.track} onChange={(e) => setF({ ...f, track: e.target.value })} className="border-white/10 bg-[#07090E]" data-testid="invite-track" />
        <button className="btn-hot !py-2" data-testid="invite-create-button">Create invite</button>
      </form>
      <div className="space-y-3">
        {list.map((i) => (
          <div key={i.id} className="panel p-5" data-testid={`invite-row-${i.slug}`}>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div><div className="font-display text-lg font-bold">{i.artist_name} <span className="text-sm text-slate-500">{i.instagram}</span></div><div className="font-mono text-xs text-slate-500">{link(i.slug)} · {fmtDate(i.created_at)}</div></div>
              <div className="flex items-center gap-3">
                <span className={`font-mono text-[11px] uppercase ${STATUS[i.status]}`} data-testid={`invite-status-${i.slug}`}>{i.status.replace("_", " ")} · {i.opens} opens</span>
                <button className="btn-ghost !px-3 !py-1.5 text-xs" onClick={() => copy(link(i.slug))} data-testid={`invite-copy-link-${i.slug}`}><Copy className="h-3.5 w-3.5" />Link</button>
                <button className="btn-ghost !px-3 !py-1.5 text-xs" onClick={() => copy(MSG.it(i))} data-testid={`invite-copy-it-${i.slug}`}>DM IT</button>
                <button className="btn-ghost !px-3 !py-1.5 text-xs" onClick={() => copy(MSG.en(i))} data-testid={`invite-copy-en-${i.slug}`}>DM EN</button>
                <button onClick={() => del(i.id)} className="text-slate-500 hover:text-[#FF2E63]" data-testid={`invite-delete-${i.slug}`}><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
